export default __webpack_public_path__ + "static/batangueno-4005ff14172edb00290aabf13aee83ff.png";